import { Component, OnInit  } from '@angular/core';
import { Router } from '@angular/router'
import { SharedService } from '../../services/shared.service'
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { FrontError } from '../../models/frontError';
import {MessageDialogComponent} from "../../dialogs/message-dialog/message-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
	selector: 'app-start',
	templateUrl: './start.component.html',
	styleUrls: ['./start.component.css']
})
export class StartComponent implements OnInit {

	constructor(
		private router: Router,
		private shared: SharedService,
		private route: ActivatedRoute,
		private http: HttpService,
    private dialog: MatDialog,
	) {
		this.shared.blockRefresh()
		this.shared.resetData()
		//this.shared.getTestData()
	}

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
				this.shared.agentId = params['agentId']
		})
		this.route.queryParams.subscribe(params => {
			this.shared.storename = params['storename']
		})
    // this.showAnnouncement();

		// try {
		// 	throw "empty";
		// }
		// catch (e) {
		// 	console.log(e);
		// 	let err: FrontError = {
		// 		pageUrl: this.router.url,
		// 		moduleName: 'ngOnInit',
		// 		errorMessage: e,
		// 		sharedValue: JSON.stringify(this.shared)
		// 	 };
		// 	this.http.saveFrontError(err)
		// 	.subscribe((response) => {
		// 		if (response.success) {
		// 		}
		// 	}, (error) => {
		// 		let x = 0;
		// 	});
		// }
	}

	onPurchase(): void {
		this.router.navigateByUrl('/imei')
	}

	onOrderStatus(): void {
		this.router.navigateByUrl('/imei-with-email')
	}

  showAnnouncement(): void {
    this.dialog.open(MessageDialogComponent, {
      data: {
        title: 'System Maintenance',
        description: 'Please be advised that system access will be unavailable<br/><b>from 12 AM to 8 AM (EST) on November 10th.</b><br/><br/>We appreciate your understanding.',
        button: 'OK'
      },
      width: '600px'
    });
  }

}
